export const defaultLocale = 'en-US';

export interface LocaleEntry {
  default?: Record<string, string>;
}

const locales = {
  'en-US': async (): Promise<LocaleEntry> => import('./en-US.json'),
  'fr-FR': async (): Promise<LocaleEntry> => import('./fr-FR.json'),
  'de-DE': async (): Promise<LocaleEntry> => import('./de-DE.json'),
  'es-ES': async (): Promise<LocaleEntry> => import('./es-ES.json'),
  'fi-FI': async (): Promise<LocaleEntry> => import('./fi-FI.json'),
  'fr-CA': async (): Promise<LocaleEntry> => import('./fr-CA.json'),
  'it-IT': async (): Promise<LocaleEntry> => import('./it-IT.json'),
  'ja-JP': async (): Promise<LocaleEntry> => import('./ja-JP.json'),
  'ko-KR': async (): Promise<LocaleEntry> => import('./ko-KR.json'),
  'nl-NL': async (): Promise<LocaleEntry> => import('./nl-NL.json'),
  'pt-BR': async (): Promise<LocaleEntry> => import('./pt-BR.json'),
  'pt-PT': async (): Promise<LocaleEntry> => import('./pt-PT.json'),
  'ru-RU': async (): Promise<LocaleEntry> => import('./ru-RU.json'),
  'sv-SE': async (): Promise<LocaleEntry> => import('./sv-SE.json'),
  'th-TH': async (): Promise<LocaleEntry> => import('./th-TH.json'),
  'tr-TR': async (): Promise<LocaleEntry> => import('./tr-TR.json'),
  'zh-Hans': async (): Promise<LocaleEntry> => import('./zh-Hans.json'),
  'zh-Hant': async (): Promise<LocaleEntry> => import('./zh-Hant.json')
};

export default locales;
